import { render } from 'preact';
import { App } from './App';
import './styles/tokens.css';
import './styles/base.css';

const root = document.getElementById('app');
if (!root) throw new Error('#app missing');
render(<App />, root);
